import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDailyPlan, useTogglePlanItem, DailyPlanItem } from '../pages/my-hub/service/dailyPlan';

/**
 * FloatingTaskTracker — Sayfa altında/yanında kayan günlük görev takipçisi.
 * Kullanıcı günlük planına bağlantılı bir görev eklediğinde,
 * ilgili sayfadayken bu bileşen görünür ve görevi tamamlandı olarak işaretlemeye izin verir.
 */
const FloatingTaskTracker: React.FC = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [dismissed, setDismissed] = useState<number[]>([]);

  const { data } = useDailyPlan(undefined, () => {});

  const toggleMutation = useTogglePlanItem(
    () => toast.success('Görev tamamlandı!'),
    () => toast.error('Görev güncellenirken bir hata oluştu'),
  );

  // Mevcut sayfayla eşleşen tamamlanmamış görevleri filtrele
  const currentPath = location.pathname;
  const matchingTasks = (data?.results || []).filter(
    (item: DailyPlanItem) => !item.is_completed && item.target_url && currentPath.startsWith(item.target_url) && !dismissed.includes(item.id),
  );

  // /my-hub sayfasındayken veya eşleşen görev yoksa gösterme
  if (currentPath === '/my-hub' || matchingTasks.length === 0) return null;

  return (
    <div
      className="floating-task-tracker"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1050,
        maxWidth: collapsed ? 56 : 380,
        transition: 'max-width 0.3s ease',
      }}
    >
      {collapsed ? (
        <button className="btn btn-primary btn-icon shadow-lg rounded-circle" style={{ width: 56, height: 56 }} onClick={() => setCollapsed(false)} title="Günlük görevler">
          <i className="bi bi-calendar-check fs-3"></i>
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: 10 }}>
            {matchingTasks.length}
          </span>
        </button>
      ) : (
        <div className="card shadow-lg border border-primary" style={{ borderRadius: 12 }}>
          <div className="card-header py-3 px-4 bg-primary d-flex justify-content-between align-items-center" style={{ borderRadius: '12px 12px 0 0', minHeight: 'auto' }}>
            <span className="text-white fw-bold fs-7">
              <i className="bi bi-calendar-check text-white me-2"></i>
              Günlük Görevler ({matchingTasks.length})
            </span>
            <div className="d-flex gap-1">
              <button className="btn btn-sm btn-icon btn-color-white" onClick={() => setCollapsed(true)}>
                <i className="bi bi-dash-lg"></i>
              </button>
            </div>
          </div>
          <div className="card-body p-3">
            {matchingTasks.map((task: DailyPlanItem) => (
              <div key={task.id} className="d-flex align-items-center mb-2 p-2 bg-gray-100 rounded">
                <div className="flex-grow-1 me-2">
                  <span className="fw-semibold text-gray-800 fs-8 d-block">{task.title}</span>
                  {task.target_label && <span className="text-gray-500 fs-9">{task.target_label}</span>}
                </div>
                <div className="d-flex gap-1">
                  <button className="btn btn-sm btn-success py-1 px-3" onClick={() => toggleMutation.mutate({ id: task.id })} disabled={toggleMutation.isLoading}>
                    <i className="bi bi-check2 me-1"></i>
                    Tamamla
                  </button>
                  <button className="btn btn-sm btn-icon btn-light py-1" onClick={() => setDismissed((prev) => [...prev, task.id])} title="Gizle">
                    <i className="bi bi-x fs-7"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingTaskTracker;
